import { apiClient } from './apiClient';

export interface PatientFile {
  id: string;
  name?: string;
  fileName?: string;
  type?: string;
  date?: string;
  url?: string;
  [key: string]: any;
}

export interface PatientAccount {
  id: string;
  name: string;
  isActive: boolean;
  isAuthorized: boolean;
}

// Список документов (требует patientClinicId)
export const getDocuments = () =>
  apiClient.get<{ files: PatientFile[] }>('/webapp/documents');

// Аккаунты (родитель + дети)
export const getAccounts = () =>
  apiClient.get<{ parent: PatientAccount; children: PatientAccount[]; activeAccountId: string }>(
    '/webapp/documents/accounts'
  );

// Смена активного аккаунта
export const switchAccount = (accountId: string) =>
  apiClient.post<{ success: boolean }>('/webapp/documents/accounts/switch', { accountId });

// Запрос данных для входа в кабинет пациента (SMS/Email)
export const requestCredentials = (type: 'sms' | 'email') =>
  apiClient.post<{ success: boolean; message: string }>('/webapp/documents/request-credentials', { type });

// Авторизация в кабинете пациента
export const authDocuments = (login: string, password: string, accountId?: string) =>
  apiClient.post<{ success: boolean; requiresCode?: boolean; message?: string }>(
    '/webapp/documents/auth',
    { login, password, accountId }
  );
